export enum ManufacturingDrawingState {
    DesignerAssigned = "DesignerAssigned",
    QuoteGiven = "QuoteGiven",
    QuoteAccepted = "QuoteAccepted",
    Designing = "Designing",
    EditsRequired = "EditsRequired",
    ClientApproved = "ClientApproved",
    InternalApproved = "InternalApproved",
}
